<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 系统操作日志
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
<!--          <button class="GreenSmBtn" @click="toAddNew">导入</button>-->
        </div>
        <div class="searchForm1">
          <searchForm
            :items="items"
          >
            <template slot="last">
              <el-form-item label="业务类型">
                <el-select
                  :popper-append-to-body="false"
                  v-model="seefrom.serviceType"
                  placeholder="请选择业务类型"
                >
                  <el-option
                    v-for="(item,index) in serviceType"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="日志类型">
                <el-select
                  :popper-append-to-body="false"
                  placeholder="请选择日志类型"
                  v-model="seefrom.result"
                >
                  <el-option label="成功" value="0">成功</el-option>
                  <el-option label="失败" value="1">失败</el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开始时间" prop="startTime">
                <el-date-picker
                  v-model="seefrom.startTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择开始时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker
                  v-model="seefrom.endTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/systemOperateLog"
            :parent="self"
            :config="config"
            :other="other"
            ref="operateLogList"
          >
          </easyTable>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        serviceType: [],
        tabName: "jsgl",
        other: {},
        items: [],
        seefrom: {
          result: "",
          serviceType: "",
          startTime: "",
          endTime: "",
        },
      };
    },
    computed: {
      self() {
        return this;
      },
      config() {
        return [
          {
            prop: "userName",
            label: "操作者名称",
          },
          {
            prop: "ip",
            label: "IP地址",
          },
          {
            prop: "serviceType",
            label: "业务类型",
          },
          {
            prop: "operateType",
            label: "操作类型",
          },
          {
            prop: "handleMsg",
            label: "操作信息",
          },
          {
            prop: function(row,column){
              return row.result == 0 ? "成功" : "失败";
            },
            label: "日志类型",
          },
          {
            prop: "createTime",
            label: "记录时间",
          },
        ];
      },
      dt() {
        return dt.map(({ label }) => label);
      },
    },
    components: {
      normalNav: () => import("public/normalNav"),
      searchForm: () => import("public/searchForm"),
      easyTable: () => import("public/easyTable"),
    },
    methods: {
      initServiceType() {
        this.$axiosget(
          "operation/systemOperateLog/serviceType").then((res) => {
          this.serviceType = res.data.data;
        });
      },
      subSeefrom() {
        this.other = this.seefrom;
        this.$refs.operateLogList.pageToOne();
        this.$nextTick(this.$refs.operateLogList.getData);
      },
      reset() {
        this.seefrom = {
          serviceType: "",
          result: "",
          startTime: "",
          endTime: "",
        };
      },
    },
    mounted() {
      this.initServiceType();
    },
  };
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/ToolManagement/operateLog/index.vue